import * as React from "react";
import { forwardRef } from "react";
const SvgRightIndentIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.25 15.75H15.75V14.25H2.25V15.75ZM2.25 6V12L5.25 9L2.25 6ZM8.25 12.75H15.75V11.25H8.25V12.75ZM2.25 2.25V3.75H15.75V2.25H2.25ZM8.25 6.75H15.75V5.25H8.25V6.75ZM8.25 9.75H15.75V8.25H8.25V9.75Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgRightIndentIcon);
export { ForwardRef as ReactComponent };
